import { useState } from "react";
import InputFactory from "../../../../components/InputFactory";
import FormField from "./FormField";

function FormPage({
  minDate,
  maxDate,
  onChange,
  schema,
  schemas,
  objects,
  ...props
}) {
  const [tinNo, setTinNo] = useState("");

  const _onChange = (value, field) => {
    console.log(field, value);
    if (field === "supplier") {
      setTinNo(value?.tinNo || "N/A");
    }
    onChange(value, field);
  };
  return (
    <>
      <div className="m-0 card bg-white p-3">
        <div className="d-flex flex-column gap-3">
          <div style={{ borderBottom: "1px solid gray" }}>
            <p className="mb-1" style={{ fontSize: "0.9rem" }}>
              Details
            </p>
          </div>

          <div className="d-flex flex-column flex-md-row gap-3">
            <FormField label="Date" required>
              <InputFactory
                type="Date"
                field="date"
                required
                min={minDate}
                max={maxDate}
                placeholder="Enter Date"
                className="border border-1 border-black bg-white"
                onChange={_onChange}
              />
            </FormField>

            <FormField label="Supplier" required>
              <InputFactory
                type="Pointer"
                target="suppliers"
                schema={schema}
                schemas={schemas}
                keys={["isVatable", "tinNo", "city"]}
                field="supplier"
                includes={["all"]}
                required
                placeholder="Select Supplier"
                //   defaultValue={formData?.supplier || ""}
                className={`border border-1 border-black ${objects.length > 0 ? "bg-light" : "bg-white"}}`}
                onChange={_onChange}
                {...props}
              />
            </FormField>

            <FormField label="TIN">
              <InputFactory
                type="String"
                target="suppliers"
                //   field="supplier"
                disabled
                placeholder="000-000-000"
                value={tinNo}
                className="border border-1 border-black bg-light"
                //   onChange={onChange}
              />
            </FormField>
          </div>
        </div>
      </div>
    </>
  );
}

export default FormPage;
